<template>
    <sweet-modal :title="$t('modal_reassign_reassign')" blocking ref="editTaskList" v-on:close="editTaskListClose">
        <el-form :model="editTaskList" status-icon ref="form">
            <el-row :span="24" :gutter="20">
                <el-col :span="12">
                    <el-form-item prop="editTaskTeamId">
                        <el-select @remove-tag="removeTag" no-data-text="no date" v-model="editTaskList.editedTaskTeamId" multiple :placeholder="$t('modal_reassign_taskTeam')" style="width:100%;">
                            <el-option-group
                            class="select-group"
                            v-for="group in editTaskList.editedTaskTeam"
                            :key="group.id"
                            :label="group.label">
                            <el-option
                            v-for="item in group.children"
                            :key="item.id"
                            :label="item.label"
                            :value="item.id"
                            @click.native="handleSelectTeam(item.id)">
                            </el-option>
                            </el-option-group>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item>
                        <el-select v-model="editTaskList.editAssignedToId" :placeholder="$t('modal_reassign_assignTo')" style="width:100%;">
                            <el-option v-for="user in editTaskList.editAssignedTo"
                                       :key="user.id"
                                       :label="user.user.fullName"
                                       :value="user.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-form-item>
                <el-button @click="editTaskListSubmit" class="modal__btn" type="primary" plain size="mini">{{$t('modal_confirm')}}</el-button>
            </el-form-item>
        </el-form>
    </sweet-modal>
</template>

<script>
  import axios from 'axios';
  import Treeselect from '@riophae/vue-treeselect'
  import '@riophae/vue-treeselect/dist/vue-treeselect.css'
  import { SweetModal } from '@totalflow4/tfsweet-modal-vue';

  export default {
    name: 'ReassignTasksModal',
    components: {
      Treeselect,
      SweetModal
    },
    props:['selectedRows','activeBusinessUnitId', 'rowData'],
    data () {
      return {
        editTaskList:{
          changeAssignedTo: true,
          changeEditedTaskTeam: true,
          editAssignedToId: null,
          editAssignedTo: [],
          editedTaskTeam: [],
          editedTaskTeamId: []
        },
        usersList: []
      }
    },
    methods: {
      editTaskListOpen(){
        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/businessUnitTasks/directories?companyId=${this.$route.query.companyId}&businessUnitId=${this.activeBusinessUnitId}&operation=update`)
          .then(response => {
            const result = [{
              id: this.rowData[0].name,
              label: this.rowData[0].name,
              children: []
            }];
            response.data.companyUserList.forEach(val => {
                const user = {
                  id: val.id,
                  label: val.user.fullName,
                  status: val.status
                };
              result[0].children.push(user)
            });

            this.editTaskList.editedTaskTeam = result;
            this.$refs.editTaskList.open();
            this.usersList = response.data.companyUserList;
            loader.hide()
          })
          .catch(error => {
            console.log('An error occurred:', error);
            loader.hide()
          });
      },
      editTaskListClose(){
        // this.editTaskList.changeAssignedTo = false;
        // this.editTaskList.changeEditedTaskTeam =false;
        this.editTaskList.editAssignedTo = [];
        this.editTaskList.editedTaskTeam = [];
        this.editTaskList.editAssignedToId = null;
        this.editTaskList.editedTaskTeamId = [];
        this.usersList = []
      },
      editTaskListSubmit(){
        let businessUnitTaskIdList = [];
        for (let i = 0; i < this.selectedRows.length; i++){
          if (this.selectedRows[i].id !== 0) businessUnitTaskIdList.push(this.selectedRows[i].id)
        }
        let loader = this.$loading.show();
        axios
          .post(`/api/v1/businessUnitTasks/updateList?companyId=${this.$route.query.companyId}&businessUnitId=${this.$route.query.businessUnitId}`, {
            businessUnitTaskIdList: businessUnitTaskIdList,
            changeCompanyUserList: this.editTaskList.changeEditedTaskTeam,
            companyUserIdList: this.editTaskList.editedTaskTeamId,
            changeLeaderCompanyUser: this.editTaskList.changeAssignedTo,
            leaderCompanyUserId: this.editTaskList.editAssignedToId
          })
          .then(response => {
            this.$refs.editTaskList.close();
            this.notification(this.$t('general_success'), this.$t('modal_reassign_editTaskList'), "success");
            loader.hide();
            // TODO
            // this.setProjectRowData(id)
            this.$emit('submit', this.activeBusinessUnitId, 'first')
          })
          .catch(error => {
            console.log('An error occurred:', error);
            loader.hide()
          })
      },
      handleSelectLeader(leaderId){
        const even = (element) => element === leaderId;
        const ifUserInTeam = this.editTaskList.editedTaskTeamId.some(even);
        if (!ifUserInTeam) {
          this.editTaskList.editedTaskTeamId.push(leaderId)
        }
      },
      handleSelectTeam(userId){
        if (userId === this.editTaskList.editAssignedToId) {
          this.editTaskList.editAssignedToId = null
        }

        this.editTaskList.editAssignedTo = [];

        this.editTaskList.editedTaskTeamId.forEach(val => {
          const user = this.usersList.filter(bal => bal.id === val)[0];
          this.editTaskList.editAssignedTo.push(user)
        })
      },
      removeTag(userId){
        if(this.editTaskList.editAssignedToId === userId) {
          this.editTaskList.editAssignedToId = null
        }

        this.editTaskList.editAssignedTo = [];
        this.editTaskList.editedTaskTeamId.forEach(val => {
          const user = this.usersList.filter(bal => bal.id === val)[0];
          this.editTaskList.editAssignedTo.push(user)
        })
      },
      notification(title, message, type) {
        this.$notify({
          title: title,
          message: message,
          type: type
        });
      }
    }
  }
</script>

<style lang="less" scoped>

</style>
